var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4896 0.199951C10.9692 0.199951 9.60845 0.947457 8.76005 2.0942C7.91165 0.947457 6.55085 0.199951 5.03045 0.199951C2.45165 0.199951 0.360046 2.32355 0.360046 4.94831C0.360046 5.95914 0.519646 6.89352 0.796846 7.75995C2.12405 12.0071 6.21485 14.547 8.23925 15.2435C8.52485 15.3454 8.99525 15.3454 9.28085 15.2435C11.3052 14.547 15.396 12.0071 16.7232 7.75995C17.0004 6.89352 17.16 5.95914 17.16 4.94831C17.16 2.32355 15.0684 0.199951 12.4896 0.199951Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayHeart);
export default __webpack_public_path__ + "static/media/gray-heart.da16b0f0ac749f0911ba26e46a06586d.svg";
export { ForwardRef as ReactComponent };